import clsx from 'clsx'

import Tick from '../../../../assets/tick.svg?react'
import classes from './Rule.module.scss'

interface Props {
  isCorrect: boolean
  label: string
}
export const Rule = ({ isCorrect, label }: Props) => (
  <div
    aria-hidden={isCorrect}
    className={clsx(classes.validationRule, { [classes.isCorrect]: isCorrect })}
  >
    <Tick />
    <span>{label}</span>
  </div>
)
